module.exports = __webpack_public_path__ + "static/media/image2.2a7c9bd0.jpg";